import { useState, useEffect } from "react";

function TaxFilingHowItWorks() {
  const [activeStep, setActiveStep] = useState(1);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  const steps = [
    {
      number: 1,
      title: "Get Matched with Your Expert",
      description: "Tell us about your tax situation and we’ll match you with a licensed tax professional who specializes in your needs."
    },
    {
      number: 2,
      title: "Upload Your Documents",
      description: "Securely upload your documents in one place. Your expert reviews everything and prepares your return with accuracy and care."
    },
    {
      number: 3,
      title: "Review and Approve",
      description: "Your expert walks you through your completed return. Ask questions, confirm details, and approve when you’re ready."
    },
    {
      number: 4,
      title: "We File Your Taxes",
      description: "Once approved, your return is filed electronically with the IRS and state — accurately, securely, and handled by your expert from start to finish."
    }
  ];

  // Preload all step images
  useEffect(() => {
    const imageUrls = steps.map((step) => `${process.env.PUBLIC_URL}/images/hiw_s${step.number}.svg`);
    let loadedCount = 0;

    imageUrls.forEach((url) => {
      const img = new Image();
      img.onload = () => {
        loadedCount++;
        if (loadedCount === imageUrls.length) {
          setImagesLoaded(true);
        }
      };
      img.src = url;
    });
  }, []);

  return (
    <section className="tax-filing-how-it-works">
      {/* 1. Title */}
      <h2 className="how-it-works-title">
        How It Works
      </h2>

      {/* 2. Content (Left and Right) */}
      <div className="how-it-works-content">
        <div className="how-it-works-left">
          {imagesLoaded && steps.map((step) => (
            <img 
              key={step.number}
              src={`${process.env.PUBLIC_URL}/images/hiw_s${step.number}.svg`}
              alt={`How it works step ${step.number}`}
              className={`how-it-works-image ${activeStep === step.number ? 'active' : 'hidden'}`}
            />
          ))}
        </div>
        <div className="how-it-works-right">
          {steps.map((step) => (
            <div 
              key={step.number} 
              className={`hiw-step ${activeStep === step.number ? 'active' : 'disabled'}`}
              onClick={() => setActiveStep(step.number)}
            >
              <div 
                className={`hiw-step-number ${activeStep === step.number ? 'active' : 'disabled'}`}
              >
                {step.number}
              </div>
              <div className="hiw-step-content">
                <h3 className={`hiw-step-title ${activeStep === step.number ? 'active' : 'disabled'}`}>
                  {step.title}
                </h3>
                <p className={`hiw-step-description ${activeStep === step.number ? 'active' : 'disabled'}`}>
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TaxFilingHowItWorks;

